<template>
  <div class="wrapper">
      <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card>
            <div slot="header">
              <strong>Create Banner </strong> <small>Form</small>
            </div>
            <b-form>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="bannername" class="text-info">Banner Name</label>
                    <b-form-input type="text" class="form-control" id="bannername" placeholder="Banner Name:" v-model="bannerName" required></b-form-input>
                    <div class="invalid-feedback d-block" v-show="errors.bannername">{{ errors.bannername }}</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="campaigns" class="text-info">Select the Campaign</label>
                    <b-form-select id="campaigns" name="campaign" v-model="campaign" @change="addANewCampaign" required>
                        <option value="0">Select</option>
                        <option v-for="campaign in campaigns" :key="campaign._id" :value="campaign.code">{{campaign.name}}</option>
                        <option class="special" value="addnew">Add a new Campaign</option>
                    </b-form-select>
                    <div id="error" class="invalid-feedback d-block" v-show="errors.campaign">{{ errors.campaign }}</div>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="country" class="text-info">Select Country</label>
                    <b-form-select id="country" name="country" v-model="country" required>
                        <option value="0">Select</option>
                        <option v-for="country in countries" :key="country.value" :value="country.value">{{country.name}}</option>
                    </b-form-select>
                    <div class="invalid-feedback d-block" v-show="errors.country">{{ errors.country }}</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="bookmaker" class="text-info">Select the Bookmaker</label>
                    <b-form-select id="bookmaker" name="bookmaker" v-model="bookmaker" @change="addANewBookmaker" required>
                        <option value="0">Select</option>
                        <option v-for="bookmaker in bookmakers" :key="bookmaker._id" :value="bookmaker.code">{{bookmaker.name}}</option>
                        <option class="special" value="addnew">Add a new Bookmaker</option>
                    </b-form-select>
                    <div class="invalid-feedback d-block" v-show="errors.bookmaker">{{ errors.bookmaker }}</div>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="#device" class="text-info">Device:</label>
                    <b-form-select id="device" required v-model="device">
                        <option value="0">Select</option>
                        <option value="desktop">Desktop</option>
                        <option value="mobile">Mobile</option>
                        <option value="tablet">Tablet</option>
                    </b-form-select>
                    <div class="invalid-feedback d-block" v-show="errors.device">{{ errors.device }}</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                  <label for="bannerurl" class="text-info">Banner Url</label>
                    <b-form-input type="text" id="bannerurl" placeholder="Banner Url:  https://www.bet365.com/dl/~offer?affiliate=" v-model="bannerUrl" required></b-form-input>
                    <div class="invalid-feedback d-block" v-show="errors.bannerurl">{{ errors.bannerurl }}</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="type === 0">
                <b-col sm="6">
                  <b-form-group>
                    <!-- Trigger/Open The Modal -->
                    <label for="#openMediaGallery" class="text-info">Select image:</label>
                    <button id="openMediaGallery" class="form-control btn btn-secondary" @click.prevent="mediaGallery">Choose an image <i class="fas fa-images"></i></button>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="" class="text-info">Selected image:</label>
                    <span v-if="!image" class="appendImageName form-control">No image selected!</span>
                    <span v-if="image" class="appendImageName form-control">{{ image }}</span>
                    <div class="invalid-feedback d-block" v-show="errors.image">{{ errors.image }}</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="#resolution" class="text-info">Banner Size:</label>
                    <b-form-select id="resolution" required v-model="size" @change="addANewSize">
                      <option value="0">Select</option>
                      <option v-for="size in sizes" :key="size._id" :value="size.sizevalue">{{ size.sizename}}</option>
                      <option class="special" value="addnew">Add a new Size</option>
                    </b-form-select>
                    <div class="invalid-feedback d-block" v-show="errors.size">{{ errors.size }}</div>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="#resolution" class="text-info">Banner type:</label>
                    <b-form-select id="resolution" required v-model="type">
                      <option v-for="(name, type) in types" :key="type" :value="parseInt(type)">{{ name }}</option>
                    </b-form-select>
                    <div class="invalid-feedback d-block" v-if="type === 1 && typeof match === 'undefined'">There is no match in database.</div>
                    <div class="invalid-feedback d-block" v-show="errors.type">{{ errors.type }}</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="#device" class="text-info">HTML:</label>
                    <textarea id="bannerhtmlcode" rows="30" cols="50" class="form-control" required="required" v-model="html"></textarea>
                    <div class="invalid-feedback d-block" v-show="errors.html">{{ errors.html }}</div>
                    <br />
                  </b-form-group>
                  <b-form-group>
                    <b-button class="mr-2" type="preview" size="md" variant="info" @click.prevent="bannerPreview"><i class="fa fa-ban"></i> Preview</b-button>
                    <b-button class="mr-2" type="submit" size="md" variant="danger" @click.prevent="saveBanner"><i class="fa fa-dot-circle-o"></i> Save</b-button>
                  </b-form-group>
                  <div class="invalid-feedback d-block" v-show="errors.slug">{{ errors.slug }}</div>
                  <div class="invalid-feedback d-block" v-show="errors.general">{{ errors.general }}</div>
                  <template v-if="type === 0">
                    <p>Example Html Code: </p>
                    <h3>Template valiables :</h3>
                    <ul class="list-group">
                      <li class="list-group-item">:language</li>
                      <li class="list-group-item"> :language / will be replaced for example with: "România"</li>
                      <li class="list-group-item"> :uniqueId / will be replaced for example with: "3454vh35j53vjh354h435jvj54j"</li>
                      <li class="list-group-item"> :countryCode / will be replaced for example with: "DE"</li>
                      <li class="list-group-item"> :apiKey / will be replaced for example with: "gfs5ehybetrhre56676v5uv7uv7u"</li>
                      <li class="list-group-item"> :size / will be replaced for example with: "200x300"</li>
                      <li class="list-group-item"> :campaign / will be replaced for example with: "1"</li>
                      <li class="list-group-item"> :bookmaker / will be replaced for example with: "1"</li>
                      <li class="list-group-item"> :device / will be replaced for example with: "mobile"</li>
                      <li class="list-group-item"> :affiliateCode / will be replaced for example with: "325_200"</li>
                      <li class="list-group-item"> :bannerUrl / will be replaced for example with: "http://bet365.com/......."</li>
                      <li class="list-group-item"> :logoBanner / will be replaced for example with: "1.png"</li>
                      <li class="list-group-item"> :backgroundUrl / will be replaced for example with: "/media/banner1.jpg"</li>
                    </ul>
                    <xmp v-html="XMPhtml"></xmp>
                  </template>
                  <template v-if="type === 1">
                    <h3 class="my-3">Add variables to your template:</h3>
                    <ol class="list-group">
                      <li class="list-group-item">:home_name - Place home team name</li>
                      <li class="list-group-item">:away_name - Place away team name</li>
                      <li class="list-group-item">:book1_odds1 - Place odds for the first bookmaker</li>
                      <li class="list-group-item">:book1_oddsX - Place odds for the first bookmaker</li>
                      <li class="list-group-item">:book1_odds2 - Place odds for the first bookmaker</li>
                      <li class="list-group-item">:book2_odds1 - Place odds for the second bookmaker</li>
                      <li class="list-group-item">:book2_oddsX - Place odds for the second bookmaker</li>
                      <li class="list-group-item">:book2_odds2 - Place odds for the second bookmaker</li>
                      <li class="list-group-item">:book3_odds1 - Place odds for the third bookmaker</li>
                      <li class="list-group-item">:book3_oddsX - Place odds for the third bookmaker</li>
                      <li class="list-group-item">:book3_odds2 - Place odds for the third bookmaker</li>
                    </ol>
                    <br>
                    <p>Example of svg template:</p>
                    <iframe class="d-block w-100 my-3" :srcdoc="DynamicBannerHtmlExample" frameborder="0"></iframe>
                  </template>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
     </b-row>
    </div>
      <!-- Modals -->
        <add-bookmaker></add-bookmaker>
        <add-campaign></add-campaign>
        <add-a-new-size></add-a-new-size>
        <banner-preview></banner-preview>
        <media-gallery :size="size"></media-gallery>
        <!-- End of Modals -->
  </div>
</template>

<script>
import { Bus } from '@/main'
import AddBookmakerModal from '@/views/modals/AddBookmakerModal'
import AddCampaignModal from '@/views/modals/AddCampaignModal'
import AddNewSizeModal from '@/views/modals/AddNewSizeModal'
import PreviewModal from '@/views/modals/PreviewModal'
import MediaGalleryModal from '@/views/modals/MediaGalleryModal'

import { mapGetters } from 'vuex'
import { collect } from 'collect.js'

export default {

  name: 'Create',
  components: {
    'add-bookmaker': AddBookmakerModal,
    'add-campaign': AddCampaignModal,
    'add-a-new-size': AddNewSizeModal,
    'banner-preview': PreviewModal,
    'media-gallery': MediaGalleryModal
  },
  data () {
    return {
      modalOpen: true,
      bannerName: '',
      campaigns: '',
      campaign: 0,
      country: 0,
      bookmakers: '',
      bookmaker: 0,
      bannerUrl: '',
      device: 0,
      sizes: '',
      size: 0,
      html: '',
      image: '',
      errors: {},
      match: {},
      type: 0,
      types: {
        0: 'Static',
        1: 'Dynamic'
      }
    }
  },
  methods: {

    addANewBookmaker (event) {
      if (event === 'addnew') {
        Bus.$emit('modalBookmakersOpened')
        this.$bvModal.show('bookmaker-add')
      }
    },
    addANewCampaign (event) {
      if (event === 'addnew') {
        Bus.$emit('modalCampaignsOpened')
        this.$bvModal.show('campaign-add')
      }
    },
    addANewSize (event) {
      if (event === 'addnew') {
        this.$bvModal.show('newsize-add')
      }
    },
    saveBanner () {
      this.errors = {}

      // save banner method , validation, etc
      const dateNow = Date.now()

      const formData = new FormData()

      if (this.type === 0) {
        if (this.image) {
          var extension = this.image.split('.')[1]
          var image = this.image.split('.')[0]
          formData.append('image', dateNow + '.' + extension)
        } else {
          this.errors.image = 'Image is required!'
        }
      } else {
        formData.append('image', false)
      }
      if (this.bannerName) {
        formData.append('bannername', this.bannerName)
      } else {
        this.errors.bannername = 'Banner name is required!'
      }
      if (this.bookmaker && this.bookmaker !== 0) {
        formData.append('bookmaker', this.bookmaker)
      } else {
        this.errors.bookmaker = 'Bookmaker is required!'
      }
      if (this.country && this.country !== 0) {
        formData.append('country_code', this.country)
      } else {
        this.errors.country = 'Country is required!'
      }
      if (this.campaign && this.campaign !== 0) {
        formData.append('campaign', this.campaign)
      } else {
        this.errors.campaign = 'Campaign is required!'
      }
      if (this.device && this.device !== 0) {
        formData.append('device', this.device)
      } else {
        this.errors.device = 'Device is required!'
      }
      if (this.size && this.size !== 0) {
        formData.append('size', this.size)
      } else {
        this.errors.size = 'Size is required!'
      }
      if (this.html) {
        formData.append('html', this.html)
      } else {
        this.errors.html = 'HTML code is required!'
      }
      if (this.bannerUrl) {
        formData.append('bannerurl', this.bannerUrl)
      } else {
        this.errors.bannerurl = 'banner url is required!'
      }
      formData.append('type', this.type)
      // if(this.generateSlug){
      //   formData.append('slug', this.generateSlug);
      // }

      if (Object.keys(this.errors).length === 0) {
        this.$http.post(`${this.$api_url}/banner/checkIfSlugExist`, { slug: this.generateSlug }).then((data) => {
          if (data.data.message === 'true') {
            this.errors.slug = 'Duplicate slug found!'
            alert(`Duplicate banner slug found! : ${data.data.record.slug}`)
          } else {
            formData.append('slug', this.generateSlug)
          }
        }).then(() => {
          if (Object.keys(this.errors).length === 0) {
            this.$http.post(`${this.$api_url}/banner/create`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
              .then((data) => {
                // if is static
                if (this.type === 0) {
                  this.$http.post(`${this.$api_url}/mediagallery/copy/${image}/${dateNow}/${extension}`)
                    .then((success) => {
                      if (success.data.message === 'file copied succesfully') {
                        if (confirm('Banner created! Navigate to the manage page?')) {
                          this.$router.push('/banners/manage')
                        } else {
                          this.bannerName = ''
                          this.campaign = 0
                          this.country = 0
                          this.bookmaker = 0
                          this.bannerUrl = ''
                          this.device = 0
                          this.size = 0
                          this.html = ''
                          this.image = ''
                        }
                      }
                    })
                } else {
                  if (confirm('Banner created! Navigate to the manage page?')) {
                    this.$router.push('/banners/manage')
                  } else {
                    this.bannerName = ''
                    this.campaign = 0
                    this.country = 0
                    this.bookmaker = 0
                    this.bannerUrl = ''
                    this.device = 0
                    this.size = 0
                    this.html = ''
                    this.image = false
                  }
                }
              })
          } else { this.errors.general = 'Check the required fields!' }
        })
      } else { this.errors.general = 'Check the required fields!' }
    },
    getCampaigns () {
      this.$http.get(`${this.$api_url}/campaigns/all`).then((campaigns) => {
        this.campaigns = campaigns.data
      })
    },
    getBookmakers () {
      this.$http.get(`${this.$api_url}/bookmakers/all`).then((bookmakers) => {
        this.bookmakers = bookmakers.data
      })
    },
    getBannerSizes () {
      this.$http.get(`${this.$api_url}/sizes/all`).then((sizes) => {
        this.sizes = sizes.data
      })
    },
    getMediaLibraryImages () {
      // axios.get(`${this.$api_url}/sizes`).then((sizes)=>{
      //     this.sizes = sizes.data;
      // })
    },
    getMatch () {
      this.$http.get(`${this.$api_url}/matches/`).then((res) => {
        if (res.data) {
          this.match = collect(res.data.data).where('draft', false).first()
        }
      })
    },
    bannerPreview () {
      Bus.$emit('previewHtml', this.replaceTemplateVar)

      this.$bvModal.show('banner-preview')
    },
    mediaGallery () {
      this.$bvModal.show('media-gallery')
    }
  },
  computed: {
    ...mapGetters(['countries', 'XMPhtml', 'apiKey', 'DynamicBannerHtmlExample']),

    replaceTemplateVar () {
      let content = this.html

      content = content.replace(/:backgroundUrl/g, `${this.$api_url}/../media/${this.image}`)

      content = content.replace(/:bookmaker/g, `${this.bookmaker}`)

      content = content.replace(/:size/g, `${this.size}`)

      content = content.replace(/:apiKey/g, `${this.apiKey}`)

      content = content.replace(/:campaign/g, `${this.campaign}`)

      content = content.replace(/:countryCode/g, `${this.country}`)

      content = content.replace(/:logoBanner/g, `${this.$api_url}/../img/${this.bookmaker}.png`)

      content = content.replace(/:bannerUrl/g, `${this.bannerurl}:affiliateCode`)

      content = content.replace(/:affiliateCode/g, '325_200')

      content = content.replace(/:device/g, `${this.device}`)

      content = content.replace(/:uniqueId/g, 'zfrdvrtc65ec')

      content = content.replace(/:home_name/g, this.match?.home_name)

      content = content.replace(/:away_name/g, this.match?.away_name)

      content = content.replace(/:book1_odds1/g, this.match?.odds[0]?.odd[0]?._attributes?.value)

      content = content.replace(/:book1_oddsX/g, this.match?.odds[0]?.odd[2]?._attributes?.value)

      content = content.replace(/:book1_odds2/g, this.match?.odds[0]?.odd[1]?._attributes?.value)

      content = content.replace(/:book2_odds1/g, this.match?.odds[1]?.odd[0]?._attributes?.value)

      content = content.replace(/:book2_oddsX/g, this.match?.odds[1]?.odd[2]?._attributes?.value)

      content = content.replace(/:book2_odds2/g, this.match?.odds[1]?.odd[1]?._attributes?.value)

      content = content.replace(/:book3_odds1/g, this.match?.odds[2]?.odd[0]?._attributes?.value)

      content = content.replace(/:book3_oddsX/g, this.match?.odds[2]?.odd[2]?._attributes?.value)

      content = content.replace(/:book3_odds2/g, this.match?.odds[2]?.odd[1]?._attributes?.value)

      content = content.replace(/:hour/g, this.match?.time)
      content = content.replace(/:date/g, this.match?.date)

      return content
    },
    generateSlug () {
      return `/${this.bookmaker}/:affCode/${this.country}/${this.device}/${this.size}/:apiKey?campaign=${this.campaign}`
    }
  },
  created () {
    this.getCampaigns()
    this.getBookmakers()
    this.getBannerSizes()
    this.getMatch()

    Bus.$on('reloadBookmakers', (data) => {
      this.getBookmakers()
      this.bookmaker = data.code
    })
    Bus.$on('reloadCampaigns', (data) => {
      this.getCampaigns()
      this.campaign = data.code
    })
    Bus.$on('reloadBannerSizes', (data) => {
      this.getBannerSizes()
      this.size = data.sizevalue
    })
    Bus.$on('imageSelected', (data) => {
      this.image = data
      this.$bvModal.hide('media-gallery')
    })
  },
  beforeDestroy () {
    Bus.$off('reloadBookmakers')
    Bus.$off('reloadCampaigns')
    Bus.$off('reloadBannerSizes')
    Bus.$off('imageSelected')
  }
}
</script>

<style scoped>
 xmp {
   overflow: auto;
 }
</style>
